import React from "react"

// normalize CSS across browsers
import "./src/css/normalize.css"

// custom CSS styles
import "./src/css/style.scss"

import { SearchProvider } from "./src/context/SearchContext"

// export function shouldUpdateScroll( prevRouterProps, { location }) {
//     console.log( 'Should update scroll...', prevRouterProps, location )
//     const element = document.getElementById('___gatsby')
//     if ( element ) {
//         // element.scrollIntoView({ behavior: 'smooth' })
//         window.setTimeout(() => window.scrollTo(0, 0), 10)
//     }
//     return false
// }

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  // For "back" and "forward" navigation, restore the saved scroll position
  const savedPosition = getSavedScrollPosition( location )
  if ( savedPosition ) {
    window.scrollTo( ...savedPosition )
  } else {
    // For "normal" navigation, scroll to top
    window.scrollTo( 0, 0 )
  }
  return false // prevents Gatsby's default scroll handling
}

// export const onRouteUpdate = ({ location }) => {
//     const element = document.getElementById('___gatsby')
//     if ( element ) {
//         element.scrollIntoView({ behavior: 'smooth' })
//     }
// }

export const wrapRootElement = ({ element }) => (
    <SearchProvider>{element}</SearchProvider>
) 
